import React, { useState, useEffect } from "react";
import CommentForm from "./CommentForm";
import Comment from "./Comment";
import Accordian from "./Accordian";
import auth from "../../../services/authservice";
import {saveInternalPost, deleteInternalPost} from "../../../services/internalposts"
import "./comments.css";

const Comments = ({ createdAt, topicId, comments: allComments }) => {
  const [comments, setComments] = useState(allComments || []);
  const [user, setUser] = useState({});
  const [activeComment, setActiveComment] = useState({});

  const rootComments = comments.filter((note) => {
    return note.parentId === null;
  });

  const replies = (noteId) => {
    return comments
      .filter((note) => {
        return note.parentId === noteId;
      })
      .sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
      );
  };

  const saveComments = async (note) => {
    try {
      const afterSave = await saveInternalPost(note);

      if (afterSave.status == 200) {
        setActiveComment({});
        setComments((prevComments) => [...prevComments, afterSave.data]);
      } else {
        window.alert(afterSave.statusText);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onSubmitComments = (text) => {

    if (text == "" || null || undefined) {
      window.alert("Comment is empty!");
      return;
    }

    const newComment = {
      narrative: text,
      parentId: null,
      topicId: topicId,
      status: "active",
      user: user._id,
      createdAt: createdAt,
    };

    saveComments(newComment);
  };

  const replyComment = (text, parrentId) => {
    if (text == "" || null || undefined) {
      window.alert("Reply is empty write Something.!");
      return;
    }

    const newComment = {
      narrative: text,
      parentId: parrentId,
      topicId: topicId,
      user: user._id,
      createdAt: createdAt,
    };

    saveComments(newComment);
  };

  const deleteComment = async (id) => {
    console.log("add note", id);

    if (window.confirm("Are you sure you want to remove comment?")) {
      try {
        const res = await deleteInternalPost(id);
        console.log(res);
        if (res.status == 200) {
          window.alert("Notes deleted.!");
          setComments((prevComments) => prevComments.filter((c) => c._id !== id));
        } else {
          window.alert(res.statusText);
        }
      } catch (e) {
        window.alert(e);
      }
    }
  };

  const updateComment = async (newComment) => {
    try {
      const res = await saveInternalPost(newComment);

      if (res.status == 200) {
        setActiveComment({});
        setComments((prevComments) =>
          prevComments.map((c) => (c._id === newComment._id ? newComment : c))
        );
      } else {
        window.alert(res.statusText);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleActiveComment = (res) => {
    setActiveComment(res);
  };

  const getUser = async () => {
    const u = await auth.getProfile();
    setUser(u);
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className="panel-body">
      <fieldset>
        <legend className="legend-text">Comments</legend>
        <CommentForm
          handleSubmit={onSubmitComments}
          submitLabel="Submit"
          initialText=""
        />
        <br />
        <hr />
        <br />
        <div className="notes-container">
          {rootComments?.map((comment) => {
            {
              return comment.parrentId == null ? (
                <Accordian title={`${comment?.user?.contactName?.first} ${comment?.user?.contactName?.last}`} date={comment.createdOn}>
                  <Comment
                    comment={comment}
                    replies={replies(comment._id)}
                    data={comments}
                    activeComment={activeComment}
                    handleActiveComment={handleActiveComment}
                    addComment={replyComment}
                    deleteComment={deleteComment}
                    updateComment={updateComment}
                    currentUserId={user._id}
                  />
                </Accordian>
              ) : (
                <Comment
                  comment={comment}
                  replies={replies(comment.id)}
                  data={comments}
                  activeComment={activeComment}
                  handleActiveComment={handleActiveComment}
                  addNote={replyComment}
                  deleteComment={deleteComment}
                  updateComment={updateComment}
                  currentUserId={user._id}
                />
              );
            }
          })}
        </div>
      </fieldset>
    </div>
  );
};

export default Comments;